import { DATE_FORMAT } from "../../Utils/dateFormat";
import React, { useEffect, useState } from "react"

import "./ListOfSales.css"
import "../../Components/Commons/Commons.css"

import SidebarMenu from "../../Components/Sidebar/Sidebar"
import AntDTable from "../../Components/AntDTable/AntDTable"
import BtnDelete from "../../Components/Commons/Buttons/BtnDelete"
import DeleteModal from "../../Components/Modals/DeleteModal"
import AddSales from "./AddSales"
import EditSales from "./EditSales"
import BtnExcel from "../../Components/Commons/Buttons/BtnExcel"

import { Col, Row } from "react-bootstrap"
import { DatePicker } from "antd"
import {
  deleteSales,
  getListOfSales,
} from "../../Components/Helpers/API/PharmacyApi/PharmacyApi"
import { formatDate } from "../../Assets/Helpers/Common"
import {
  formatPrice,
  getTodayDateISO,
} from "../../Components/Helpers/Utilities/Common"
import { getInventories } from "../../Components/Helpers/API/InventoryApi/InventoryApi"
import { toast } from "react-toastify"

const { RangePicker } = DatePicker

function ListOfSales() {
  const [data, setData] = useState([])
  const [totalSales, setTotalSales] = useState(0)
  const [inventories, setInventories] = useState([])
  const [selectedRow, setSelectedRow] = useState({})
  const [showDelete, setShowDelete] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [dateRange, setDateRange] = useState([])

  // function for adding button in the table
  function ActionBtn(row) {
    return (
      <>
        <Row className="center">
          <Col >
            <EditSales refetch={fetchListOfSales} initialValues={row.row} />
          </Col>
          <Col>
            <BtnDelete
              outline
              label={"Delete"}
              size={"sm"}
              onClick={(e) => {
                setSelectedRow(row.row)
                setShowDelete(true)
              }}
            />
          </Col>
        </Row>
      </>
    )
  }
  //get sales data API
  const fetchListOfSales = async () => {
    setShowLoader(true)
    const res = await getListOfSales({
      date_from: dateRange.length > 0 ? dateRange[0] : "",
      date_to: dateRange.length > 1 ? dateRange[1] : "",
    })
    if (res.data) {
      setTotalSales(res.data.data.total_sales)
      var _parsed = res.data.data.sales.map((sale) => ({
        id: sale.id,
        inventory_id: sale.inventory_id,
        sales_date: sale.sales_date ? formatDate(sale.sales_date) : "-",
        item_name: sale.item_name,
        unit_price: formatPrice(sale.unit_price),
        quantity: formatPrice(sale.quantity),
        total: formatPrice(sale.total),
        remarks: sale.remarks,
        patient_name: sale.patient_name,
      }))
      setData(_parsed)
    } else if (res.error) {
      setData([])
    }

    setShowLoader(false)
  }

  // Delete sales API
  const handleDelete = async () => {
    const res = await deleteSales(selectedRow.id)

    if (res.data) {
      toast.success(res.data.message)
      setShowDelete(false)
      setSelectedRow({})
      fetchListOfSales()
    } else if (res.error) {
      toast.error(res.error)
    }
  }

  //get Inventories API
  async function fetchInventories() {
    const res = await getInventories()

    if (res.data) {
      var _parsed = res.data.data.map((inventory) => ({
        ...inventory,
        value: inventory.id,
        label: inventory.item,
      }))
      setInventories(_parsed)
    }
  }

  // function getting the date
  const onDateChange = (dateString) => {
    setDateRange(dateString)
  }

  useEffect(() => {
    fetchInventories()
  }, [])

  useEffect(() => {
    fetchListOfSales()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRange])

  return (
    <div className="App">
      <SidebarMenu active={"Pharmacy"} />
      <div className="col p-5 pt-4 listOfSales-whole-container">
        <div className="row">
          <div className="col font-big title-2 all-patient">
            List of Sales
          </div>
          <div className="col-2 flex patient-manager exportExcel-buttons">
            <BtnExcel
              label={"Export to Excel"}
              size={"sm"}
              excelData={data}
              xlsxHeaders={[
                "DATE",
                "ITEM NAME",
                "UNIT PRICE",
                "QUANTITY",
                "TOTAL",
                "PATIENT NAME",
                "REMARKS",
              ]}
              fileName={`${getTodayDateISO()}_Sales_Report.xlsx`}
            />
          </div>
          <div className="col-2 patient-manager addSales-buttons">
            <AddSales inventories={inventories} refetch={fetchListOfSales} />
          </div>
        </div>

        <Row className="my-4">
          <Col>
            <span>Filter by: </span>
            <RangePicker format={DATE_FORMAT} onChange={onDateChange} />
          </Col>
          <Col className="d-flex justify-content-end font-bold listOfSales-total-sales">
            Total Sales = Php {formatPrice(totalSales)}
          </Col>
        </Row>

        <div className="row justify-content-center">
          <div className="col-sm-12 all-table listOfSales-table">
            <AntDTable
              tableHeaders={[
                "SALES DATE",
                "ITEM NAME",
                "UNIT PRICE",
                "QUANTITY",
                "TOTAL",
                "PATIENT NAME",
                "REMARKS",
              ]}
              headerSelector={[
                "sales_date",
                "item_name",
                "unit_price",
                "quantity",
                "total",
                "patient_name",
                "remarks",
              ]}
              tableData={data}
              ActionBtn={(row) => ActionBtn(row)}
              loading={showLoader}
              withAction={true}
            />
          </div>
        </div>
      </div>
      <DeleteModal
        title={`Do you want to delete this sale record?`}
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
      />
    </div>
  )
}

export default ListOfSales
